import styled from 'styled-components';

import { ReactComponent as LogoVORYQSVG } from '../../../assets/logo/logo-voryq.svg';

export const LogoVORYQ = styled(LogoVORYQSVG)`
  width: 200px;
  /* width: 156.9px;
  height: 50px; */
`;
